<template>
    <div>
        <footer>
            <div class="footer-stage1">
                <div class="wrap">
                    <div>
                        <h6>{{ $t('contact.contact_us') }}</h6>
                        <span class="footer-address" v-html="$t('contact.address')"></span>
                        <a href="https://www.ewc-rdc.ca/pub/en/contact_us">{{ $t('contact.emailus') }}</a>
                    </div>

                    <div>
                        <h6>{{ $t('contact.rent') }}</h6>

                        <a v-if="this.$i18n.locale == 'en' " :href="$t('contact.logo')"><img src="../assets/img/rent_en.png" ></a>
                        <a v-else :href="$t('contact.logo')"><img src="../assets/img/rent_fr.png" ></a>
                    </div>

                    <div>
                        <h6>{{ $t('contact.connectwithus') }}</h6>
                        <ul class="footer-social">
                            <li><a :href="$t('contact.facebook')"><img alt="facebook" title="facebook" src="../assets/img/fb.png"></a></li>
                            <li><a :href="$t('contact.twitter')"><img alt="twitter" title="twitter" src="../assets/img/twitter.png"></a></li>
                            <li><a :href="$t('contact.youtube')"><img alt="youtube" title="youtube" src="../assets/img/youtube.png"></a></li>
                            <li><a :href="$t('contact.instagram')"><img alt="instagram" title="instagram" src="../assets/img/instagram.png"></a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer-stage2">
                <div class="wrap">
                    <div class="footer-historica">
                        <span>{{ $t('contact.programof') }}</span>
                        <a href="http://www.canada.ca"><img src="../assets/img/histo.png" ></a>
                    </div>

                    <div>
                        <ul>
                            <li v-html="$t('contact.policies')"></li>
                            <li v-html="$t('contact.community')"><li>
                            <li v-html="$t('contact.confidentiality')"></li>
                        </ul>
                    </div>

                    <div>
                        {{ $t('contact.participation') }}
                        <a class="footer-canada-logo" href="http://www.canada.ca"><img src="../assets/img/canada_wordmark.png" ></a>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>

export default {
    name: 'TheFooter',
    methods: {
    },
    mounted: function (){

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue